var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"p-30"},[_vm._v("よくあるご質問（ご利用登録前）")])}
var staticRenderFns = []

export { render, staticRenderFns }